import { TMakeBreadcrumbFn } from './composeMakeBreadcrumb';

type THint = {
  input?: [string, { body: string }];
  [key: string]: any;
};

export const makeGraphqlBreadcrumb: TMakeBreadcrumbFn = (
  breadcrumb,
  hint?: THint | undefined,
) => {
  const result = { ...breadcrumb, data: { ...breadcrumb.data } };

  if (result.category !== 'fetch' || !result.data?.['graphql.document']) {
    return breadcrumb;
  }

  delete result.data['graphql.document'];

  const operation = result.data['graphql.operation'] as string;
  const body = hint?.input?.[1]?.body;

  // We do not want to include mutations
  if (body && operation?.startsWith('query')) {
    const parsedBody = JSON.parse(body) as {
      variables: { [key: string]: string };
    };

    result.data['graphql.variables'] = parsedBody.variables || null;
  }

  return result;
};
